// extracted by mini-css-extract-plugin
export var bodyRow = "_c6-d";
export var cardColumns = "_c6-e";
export var ellipsesOverflow = "_c6-2";
export var flatBottomCorners = "_c6-3";
export var flatTopCorners = "_c6-4";
export var headerActionsDropdown = "_c6-f";
export var headerBottomRow = "_c6-c";
export var headerTopRow = "_c6-b";
export var orderDetailsWrapper = "_c6-0";
export var orderInfoContainer = "_c6-1";
export var productDetails = "_c6-9";
export var productImage = "_c6-5";
export var responsiveTable = "_c6-8";
export var shipmentContainer = "_c6-a";
export var tableBottomLeft = "_c6-6";
export var tableBottomRight = "_c6-7";
export var trackingLink = "_c6-g";